import RevokeAccess from './RevokeAccess';

export default RevokeAccess;
